// extracted by css-extract-rspack-plugin
export default {"Token":"TokenizedQuery-module__Token__e6tYw"};